var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 25H28.3333V28.3333H18.3333V25ZM15 11.6667H11.6667V15H15V11.6667ZM18.3333 21.6667H28.3333V18.3333H18.3333V21.6667ZM18.3333 15H28.3333V11.6667H18.3333V15ZM15 18.3333H11.6667V21.6667H15V18.3333ZM35 8.33333V31.6667C35 33.5 33.5 35 31.6667 35H8.33333C6.5 35 5 33.5 5 31.6667V8.33333C5 6.5 6.5 5 8.33333 5H31.6667C33.5 5 35 6.5 35 8.33333ZM31.6667 8.33333H8.33333V31.6667H31.6667V8.33333ZM15 25H11.6667V28.3333H15V25Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetIcon);
export default __webpack_public_path__ + "static/media/asset_icon.6b2565736fda4b3ee54281126c850f74.svg";
export { ForwardRef as ReactComponent };